// A text field of the schedule panel that is saved on Enter or on leaving it (R-S6): what the person types is theirs until it is
// sent — an answer of the server that comes while they type does not replace it (audit 31.10, P2-9).

/** `base` — the last value of the server (or the one just sent); `edited` — typed since then. */
export interface FieldDraft { text: string; base: string; edited: boolean; focused: boolean }

export const fieldDraft = (value: string, focused = false): FieldDraft => ({ text: value, base: value, edited: false, focused });

/** The server's value arrives: it is shown unless the person is typing in the field — then it only becomes the base. */
export const fromServer = (d: FieldDraft, value: string): FieldDraft => (d.focused && d.edited ? { ...d, base: value } : fieldDraft(value, d.focused));

export const typed = (d: FieldDraft, text: string): FieldDraft => ({ ...d, text, edited: true });

/** Enter or leaving the field: what to send (null — nothing changed), and the field after it. */
export function commitDraft(d: FieldDraft): { send: string | null; next: FieldDraft } {
  const send = d.edited && d.text !== d.base ? d.text : null;
  return { send, next: { ...d, edited: false, base: send ?? d.base } };
}
